import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IData } from '../../models/api/data';
import { IError } from '../../models/error/error';
import { IAccess } from '../../permissions/model/access';

const urlGetAllAccessGroup = () => ['lab', 'admin', 'access', 'access-group'];
const urlGetAlLAccessGroupEmployee = (accessGroupId: string) => ['lab', 'admin', 'access', 'access-group', accessGroupId, 'employee'];

@Service()
export class AccessGroupService {
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    // CLINIC
    getUserPermission(): Observable<IData<IAccess[]>> {
        const baseUrl = ['clinic', 'admin', 'access', 'access-group-permission', 'user'];

        const url = this.router.createUrlTree(baseUrl);

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        return this.httpClient.get(parsedUrl, { responseType: 'json' }).pipe(
            map((res: IData<IAccess[]>) => {
                return res;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    return throwError(() => `Error: ${error.error.message}`);
                }
                const errorApi: IError = error.error.error;
                return throwError(() => errorApi);
            }),
        );
    }
}
